import { type BrokersQualifyingLifeEvent } from 'utils/web_api.schemas'

type SourceInfoSectionProps = {
  source?: string
  enrollmentEventId?: string
  qualifyingLifeEvent?: BrokersQualifyingLifeEvent
}

// Format source for display (e.g., "member_onboarding" -> "Member Onboarding")
const formatSource = (source: string) => {
  return source
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const SourceInfoSection = ({
  source,
  enrollmentEventId,
  qualifyingLifeEvent,
}: SourceInfoSectionProps) => {
  const hasSource = !!source
  const hasEnrollmentEventId = !!enrollmentEventId
  const hasQle = !!qualifyingLifeEvent

  if (!hasSource && !hasEnrollmentEventId && !hasQle) {
    return null
  }

  return (
    <div className='space-y-2'>
      <h6 className='font-medium text-sm text-gray-600'>Source Info:</h6>
      <div className='grid grid-cols-1 gap-2'>
        {hasSource && (
          <div>
            <span className='text-xs text-gray-500'>Source</span>
            <p className='text-sm text-gray-900'>{formatSource(source!)}</p>
          </div>
        )}
        {hasEnrollmentEventId && (
          <div>
            <span className='text-xs text-gray-500'>Enrollment Event ID</span>
            <p className='text-sm text-gray-900 font-mono'>{enrollmentEventId}</p>
          </div>
        )}
        {hasQle && (
          <div>
            <span className='text-xs text-gray-500'>Qualifying Life Event</span>
            <p className='text-sm text-gray-900'>
              {formatSource(qualifyingLifeEvent!.type)}
            </p>
            <p className='text-xs text-gray-500 font-mono'>
              {qualifyingLifeEvent!.id}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default SourceInfoSection
